
// // import React, { useEffect, useState } from 'react';
// // import AdminAppBody from '../../../../components/admin/AdminAppBody';
// // import useApiCallHooks from '../../../../hooks/useApiCallHooks';
// // import { useNavigate } from 'react-router-dom';

// // const Projectstudentinfo = () => {
// //   const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
// //   const navigate = useNavigate();

// //   const [projects, setProjects] = useState([
// //     { name: '', key_skill: '', description: '' }
// //   ]);

// //   // 🔹 Fetch profile data to prefill projects
// //   useEffect(() => {
// //     callAPI('get', 'student/get-student-profile-data');
// //   }, []);

// //   useEffect(() => {
// //     if (statusCode === 200 && responce?.data?.projects) {
// //       // Use existing projects or default if none
// //       if (responce.data.projects.length > 0) {
// //         setProjects(responce.data.projects);
// //       }
// //     }
// //   }, [responce, statusCode]);

// //   // 🔹 Handle input changes
// //   const handleProjectChange = (index, e) => {
// //     const updated = [...projects];
// //     updated[index][e.target.name] = e.target.value;
// //     setProjects(updated);
// //   };

// //   // 🔹 Add new empty project
// //   const addProject = () => {
// //     setProjects([...projects, { name: '', key_skill: '', description: '' }]);
// //   };

// //   // 🔹 Remove project
// //   const removeProject = (index) => {
// //     const updated = [...projects];
// //     updated.splice(index, 1);
// //     setProjects(updated);
// //   };

// //   // 🔹 Submit
// //   const updateproject = (e) => {
// //     e.preventDefault();
// //     callAPI('post', 'student/add-student-project', { projects });
// //   };

// //   // 🔹 Redirect after submit
// //   useEffect(() => {
// //     if (statusCode === 201 || statusCode === 202) {
// //       navigate("/student/profile");
// //     }
// //   }, [statusCode, navigate]);

// //   return (
   
// //     <div className="card p-4 shadow-sm">
// //       <div className="d-flex justify-content-between align-items-center mb-3">
// //         <h5 className="mb-0">Projects</h5>
// //         <button type="button" className="btn btn-primary" onClick={addProject}>Add Project</button>
// //       </div>
// //       <form onSubmit={updateproject}>
// //         {projects.map((project, index) => (
// //           <div key={index} className="bg-light p-3 mb-3 rounded">
// //             <div className="row g-3">
// //               <div className="col-md-6">
// //                 <label>Project Name</label>
// //                 <input
// //                   type="text"
// //                   name="name"
// //                   value={project.name}
// //                   onChange={(e) => handleProjectChange(index, e)}
// //                   className="form-control"
// //                 />
// //               </div>
// //               <div className="col-md-6">
// //                 <label>Key Skill</label>
// //                 <input
// //                   type="text"
// //                   name="key_skill"
// //                   value={project.key_skill}
// //                   onChange={(e) => handleProjectChange(index, e)}
// //                   className="form-control"
// //                 />
// //               </div>
// //               <div className="col-md-12">
// //                 <label>Description</label>
// //                 <textarea
// //                   name="description"
// //                   value={project.description}
// //                   onChange={(e) => handleProjectChange(index, e)}
// //                   className="form-control"
// //                   rows="3"
// //                 />
// //               </div>
// //               {projects.length > 1 && (
// //                 <div className="col-12 text-end">
// //                   <button type="button" className="btn btn-danger btn-sm" onClick={() => removeProject(index)}>Remove</button>
// //                 </div>
// //               )}
// //             </div>
// //           </div>
// //         ))}
// //         <div className="text-end">
// //           <button type="submit" className="btn btn-primary">Submit Projects</button>
// //         </div>
// //       </form>
// //     </div>
// //   );
// // };

// // export default Projectstudentinfo;


// import React, { useEffect, useState } from 'react';
// import AdminAppBody from '../../../../components/admin/AdminAppBody';
// import useApiCallHooks from '../../../../hooks/useApiCallHooks';
// import { useNavigate } from 'react-router-dom';

// const Projectstudentinfo = () => {
//   const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
//   const navigate = useNavigate();

//   const [projects, setProjects] = useState([
//     { name: '', key_skill: '', description: '' }
//   ]);

//   // 🔹 Fetch profile data to prefill projects
//   useEffect(() => {
//     callAPI('get', 'student/get-student-profile-data');
//   }, []);

//   useEffect(() => {
//     if (statusCode === 200 && responce?.data?.projects) {
//       if (responce.data.projects.length > 0) {
//         setProjects(responce.data.projects);
//       }
//     }
//   }, [responce, statusCode]);

//   // 🔹 Handle input change
//   const handleProjectChange = (index, e) => {
//     const updated = [...projects];
//     updated[index][e.target.name] = e.target.value;
//     setProjects(updated);
//   };

//   // 🔹 Add new project
//   const addProject = () => {
//     setProjects([...projects, { name: '', key_skill: '', description: '' }]);
//   };

//   // 🔹 Remove project with delete API if project has ID
//   const removeProject = (index) => {
//     const projectToRemove = projects[index];

//     if (projectToRemove.id) {
//       // Confirm delete
//       if (window.confirm('Are you sure you want to delete this project?')) {
//         callAPI('post', 'student/remove-student-project', { id: projectToRemove.id });
//       }
//     }

//     // Remove locally
//     const updated = [...projects];
//     updated.splice(index, 1);
//     setProjects(updated);
//   };

//   // 🔹 Submit all projects
//   const updateproject = (e) => {
//     e.preventDefault();
//     callAPI('post', 'student/add-student-project', { projects });
//   };

//   // 🔹 Redirect after submit
//   useEffect(() => {
//     if (statusCode === 201 || statusCode === 202) {
//       navigate("/student/profile");
//     }
//   }, [statusCode, navigate]);

//   return (
//     <div className="card p-4 shadow-sm">
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <h5 className="mb-0">Projects</h5>
//         <button type="button" className="btn btn-primary" onClick={addProject}>Add Project</button>
//       </div>

//       <form onSubmit={updateproject}>
//         {projects.map((project, index) => (
//           <div key={index} className="bg-light p-3 mb-3 rounded">
//             <div className="row g-3">
//               <div className="col-md-6">
//                 <label>Project Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={project.name}
//                   onChange={(e) => handleProjectChange(index, e)}
//                   className="form-control"
//                 />
//               </div>
//               <div className="col-md-6">
//                 <label>Key Skill</label>
//                 <input
//                   type="text"
//                   name="key_skill"
//                   value={project.key_skill}
//                   onChange={(e) => handleProjectChange(index, e)}
//                   className="form-control"
//                 />
//               </div>
//               <div className="col-md-12">
//                 <label>Description</label>
//                 <textarea
//                   name="description"
//                   value={project.description}
//                   onChange={(e) => handleProjectChange(index, e)}
//                   className="form-control"
//                   rows="3"
//                 />
//               </div>
//               {projects.length > 1 && (
//                 <div className="col-12 text-end">
//                   <button
//                     type="button"
//                     className="btn btn-danger btn-sm"
//                     onClick={() => removeProject(index)}
//                   >
//                     Remove
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         ))}
//         <div className="text-end">
//           <button type="submit" className="btn btn-primary">Submit Projects</button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Projectstudentinfo;


import React, { useEffect, useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; // ✅ added
const Projectstudentinfo = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();
  const [projects, setProjects] = useState([
    { name: '', key_skill: '', description: '' }
  ]);
  // 🔹 Fetch profile data to prefill projects
  useEffect(() => {
    callAPI('get', 'student/get-student-profile-data');
  }, []);
  useEffect(() => {
    if (statusCode === 200 && responce?.data?.projects) {
      if (responce.data.projects.length > 0) {
        setProjects(responce.data.projects);
      }
    }
  }, [responce, statusCode]);
  // 🔹 Handle input change
  const handleProjectChange = (index, e) => {
    const updated = [...projects];
    updated[index][e.target.name] = e.target.value;
    setProjects(updated);
  };
  // 🔹 Add new project
  const addProject = () => {
    setProjects([...projects, { name: '', key_skill: '', description: '' }]);
  };
  // 🔹 Remove project with delete API if project has ID
  const removeProject = (index) => {
    const projectToRemove = projects[index];
    if (projectToRemove.id) {
      // Confirm delete
      if (window.confirm('Are you sure you want to delete this project?')) {
        callAPI('post', 'student/remove-student-project', { id: projectToRemove.id });
      }
    }
    // Remove locally
    const updated = [...projects];
    updated.splice(index, 1);
    setProjects(updated);
  };
  // 🔹 Submit all projects
  const updateproject = (e) => {
    e.preventDefault();
    callAPI('post', 'student/add-student-project', { projects });
  };
  // ✅ Unified effect to handle toast + navigation
  useEffect(() => {
    if (statusCode === 201 || statusCode === 202) {
      toast.success("✅ Projects updated successfully!", {
        autoClose: 2000,
      });
      setTimeout(() => {
        navigate("/student/profile");
      }, 1000);}
   
     }, [statusCode, navigate]);
  return (
    <div className="card p-4 shadow-sm">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Projects</h5>
        <button type="button" className="btn btn-primary" onClick={addProject}>Add Project</button>
      </div>
      <form onSubmit={updateproject}>
        {projects.map((project, index) => (
          <div key={index} className="bg-light p-3 mb-3 rounded">
            <div className="row g-3">
              <div className="col-md-6">
                <label>Project Name</label>
                <input
                  type="text"
                  name="name"
                  value={project.name}
                  onChange={(e) => handleProjectChange(index, e)}
                  className="form-control"
                />
              </div>
              <div className="col-md-6">
                <label>Key Skill</label>
                <input
                  type="text"
                  name="key_skill"
                  value={project.key_skill}
                  onChange={(e) => handleProjectChange(index, e)}
                  className="form-control"
                />
              </div>
              <div className="col-md-12">
                <label>Description</label>
                <textarea
                  name="description"
                  value={project.description}
                  onChange={(e) => handleProjectChange(index, e)}
                  className="form-control"
                  rows="3"
                />
              </div>
              {projects.length > 1 && (
                <div className="col-12 text-end">
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => removeProject(index)}
                  >
                    Remove
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
        <div className="text-end">
          <button type="submit" className="btn btn-primary">Submit Projects</button>
        </div>
      </form>
    </div>
  );
};
export default Projectstudentinfo;